import React from 'react';
import { DebounceInput } from 'react-debounce-input';
import {
	Card,
	CardBody,
	Row,
	Col,
	Button,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	UncontrolledButtonDropdown
} from 'reactstrap';
import './controle-tarefas.styles.css';
import 'primereact/resources/themes/nova-light/theme.css';
import { controleTarefasEmum } from './controle-tarefas.utils';
import GridReceptaculos from './Recptaculos';
import GridImuno from './Imuno';
import GridCitologia from './Citologia';
import GridHistologia from './Histologia';
import IntlMessage from '../../helpers/intlMessage';
import SelectComponent from '@componentes/select/select.component';

const ControleTarefasPage = props => {
	return (
		<div className='mv-controle-tarefas-page'>
			<Card>
				<CardBody>
					<Col>
						<Row className='mv-controle-tarefas-filtro'>
							{!props.hideTitulo && (
								<Col sm={'auto'}>
									<h2 className='title-citologia'><IntlMessage id="dashboards.taskControl.general"/></h2>
								</Col>
							)}

							<Col sm='auto' style={{padding: 0}}>
								<UncontrolledButtonDropdown>
									<DropdownToggle className='button' caret style={{background: '#fff', color: '#212529', height: '38px'}}>
										{props.selectTipo}
									</DropdownToggle>
									<DropdownMenu>
										<DropdownItem
											onClick={() =>
												props.changeSelectTipo(<IntlMessage id="dashboards.taskControl.blocks"/>, controleTarefasEmum.RECEPTACULOS)
											}
										>
											<IntlMessage id="dashboards.taskControl.blocks" />
										</DropdownItem>
										<DropdownItem
											onClick={() =>
												props.changeSelectTipo(<IntlMessage id="dashboards.taskControl.immune"/>, controleTarefasEmum.IMUNO)
											}
										>
											<IntlMessage id="dashboards.taskControl.immune"/>
										</DropdownItem>
										<DropdownItem
											onClick={() =>
												props.changeSelectTipo(<IntlMessage id="dashboards.taskControl.citologySlides"/>, controleTarefasEmum.LAMINAS_CITOLOGIA)
											}
										>
											<IntlMessage id="dashboards.taskControl.citologySlides"/>
										</DropdownItem>
										<DropdownItem
											onClick={() =>
												props.changeSelectTipo(<IntlMessage id="dashboards.taskControl.histologySlides"/>, controleTarefasEmum.LAMINAS_HISTOLOGIA)
											}
										>
											<IntlMessage id="dashboards.taskControl.histologySlides"/>
										</DropdownItem>
									</DropdownMenu>
								</UncontrolledButtonDropdown>
							</Col>
							<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto'}}>
								<div className="label-data"><IntlMessage id="period.name"/></div>
								<div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
									<SelectComponent
										isClearable
										className="filtro-data"
										noOptionsMessage={<IntlMessage id="dashboards.reports.noItemsFound"/>}
										name="form-field-period"
										placeholder={<IntlMessage id="dashboards.general.selectPeriod"/>}
										value={props.periodo}
										onChange={(e) => {
										props.onChangePeriodo(e);
										e && e.value ? props.mudarIntervaloPeriodo(e.value) : props.mudarIntervaloPeriodo('todos');
										}}
										options={props.periodos}
									/>
								</div>

								{props.periodo && props.periodo.value === 'outro' && (
								<React.Fragment>
									<DebounceInput
										name="periodoDe"
										type="date"
										style={{width: '130px', display: 'block'}}
										className="filtro-data"
										value={props.dataRealizadoDe}
										onChange={e => props.atualizarDataRealizacao('dataRealizadoDe', e.target.value)}
										onKeyPress={(e) => props.onKeyPressData(e)}
									/>
									<DebounceInput
										name="periodoAte"
										type="date"
										style={{width: '130px', display: 'block'}}
										className="filtro-data"
										value={props.dataRealizadoAte}
										onChange={e => props.atualizarDataRealizacao('dataRealizadoAte', e.target.value)}
										onKeyPress={(e) => props.onKeyPressData(e)}
									/>
								</React.Fragment>
								)}
							</div>
							<Col sm='auto'>
								<Button
									className='btn btn-primary'
									onClick={props.gerarRelatorio}
									disabled={!props.dataRealizadoDe || !props.dataRealizadoAte || props.tipoRelatorio === 0}
									style={{height: '38px', width: '38px'}}
								>
									<i className='icons-btn mv-basico-pesquisar'></i>
								</Button>
							</Col>
							{((props.cassetesCriadosNoPeriodo.length > 0 && props.tipoRelatorio === controleTarefasEmum.RECEPTACULOS) ||
							  (props.laminasCriadasNoPeriodo.length > 0 && props.tipoRelatorio === controleTarefasEmum.IMUNO) ||
							  (props.laminasCriadasNoPeriodo.length > 0 && props.tipoRelatorio === controleTarefasEmum.LAMINAS_CITOLOGIA) ||
							  (props.laminasCriadasNoPeriodo.length > 0 && props.tipoRelatorio === controleTarefasEmum.LAMINAS_HISTOLOGIA)) &&
								(
									<Col>
										<Button className='btn btn-imprimir btn-success' onClick={() => props.setPreviewHTML(true)}>
											<i className='icons-btn mv-basico-imprimir'></i> <IntlMessage id="dashboards.taskControl.printOut"/>
										</Button>
									</Col>
								)}
						</Row>
					</Col>
				</CardBody>
			</Card >
			{
				props.tipoRelatorio === controleTarefasEmum.RECEPTACULOS && (
					<div>
						{!!props.cassetesCriadosNoPeriodo.length && (
							<GridReceptaculos lista={props.cassetesCriadosNoPeriodo} />
						)}
						{!props.cassetesCriadosNoPeriodo.length && <NoData />}
					</div>
				)
			}

			{
				props.tipoRelatorio === controleTarefasEmum.IMUNO && (
					<div>
						{!!props.laminasCriadasNoPeriodo.length && (
							<GridImuno lista={props.laminasCriadasNoPeriodo} />
						)}
						{!props.laminasCriadasNoPeriodo.length && <NoData />}
					</div>
				)
			}

			{
				props.tipoRelatorio === controleTarefasEmum.LAMINAS_CITOLOGIA && (
					<div>
						{!!props.laminasCriadasNoPeriodo.length && (
							<GridCitologia lista={props.laminasCriadasNoPeriodo} />
						)}
						{!props.laminasCriadasNoPeriodo.length && <NoData />}
					</div>
				)
			}

			{
				props.tipoRelatorio === controleTarefasEmum.LAMINAS_HISTOLOGIA && (
					<div>
						{!!props.laminasCriadasNoPeriodo.length && (
							<GridHistologia lista={props.laminasCriadasNoPeriodo} />
						)}
						{!props.laminasCriadasNoPeriodo.length && <NoData />}
					</div>
				)
			}

			{!props.tipoRelatorio && <NoData />}
		</div >
	);
};

function NoData() {
	return (
		<div className='icone-semdados'>
			<i className='inicial-icons mv-basico-consulta'></i>
		</div>
	);
}

export default ControleTarefasPage;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/controle-tarefas.page.js